import { render, staticRenderFns } from "./PosHeader.vue?vue&type=template&id=f5c33140&scoped=true"
import script from "./PosHeader.vue?vue&type=script&lang=js"
export * from "./PosHeader.vue?vue&type=script&lang=js"
import style0 from "./PosHeader.vue?vue&type=style&index=0&id=f5c33140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c33140",
  null
  
)

export default component.exports